import styled from '@emotion/styled'

const PaymentFailure = () => {
  return (
    <FailureContainer>
      <FailureIcon>
        <svg viewBox="0 0 24 24">
          <path
            fill="currentColor"
            d="M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z"
          />
        </svg>
      </FailureIcon>
      <FailureTitle>Payment Failed</FailureTitle>
      <FailureMessage>
        We couldn't process your payment. Please check your payment details and
        try again. If the problem persists, contact your bank or try a different
        payment method.
      </FailureMessage>
      <RetryButton>Try Again</RetryButton>
      <ContactLink href="/contact">Contact Support</ContactLink>
    </FailureContainer>
  )
}

// Styled components
const FailureContainer = styled.div`
  max-width: 500px;
  margin: 3rem auto;
  padding: 2rem;
  text-align: center;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
`

const FailureIcon = styled.div`
  width: 80px;
  height: 80px;
  margin: 0 auto 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f44336;
  border-radius: 50%;
  color: white;

  svg {
    width: 48px;
    height: 48px;
  }
`

const FailureTitle = styled.h2`
  font-size: 1.8rem;
  color: #d32f2f;
  margin-bottom: 1rem;
  font-weight: 600;
`

const FailureMessage = styled.p`
  font-size: 1.1rem;
  color: #555;
  line-height: 1.6;
  margin: 0 auto 2rem;
  max-width: 80%;
`

const RetryButton = styled.button`
  background-color: #d32f2f;
  color: white;
  border: none;
  padding: 0.8rem 1.5rem;
  font-size: 1rem;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-right: 1rem;

  &:hover {
    background-color: #b71c1c;
  }
`

const ContactLink = styled.a`
  color: #555;
  text-decoration: none;
  border: 1px solid #ddd;
  padding: 0.8rem 1.5rem;
  border-radius: 6px;
  transition: all 0.3s;

  &:hover {
    background-color: #f5f5f5;
  }
`

export default PaymentFailure
